import PropTypes from 'prop-types'

export default PropTypes.shape({
  author: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
})
